import { render, staticRenderFns } from "./SecondLevel.vue?vue&type=template&id=23857862&scoped=true"
import script from "./SecondLevel.vue?vue&type=script&lang=js"
export * from "./SecondLevel.vue?vue&type=script&lang=js"
import style0 from "./SecondLevel.vue?vue&type=style&index=0&id=23857862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23857862",
  null
  
)

export default component.exports